
import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { ApiUrlContext } from "../App";

function LoginPage({ onAuth }) {

  const apiUrl = useContext(ApiUrlContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 8) {
      setError("Şifre en az 8 karakter olmalı.");
      return;
    }
    try {
      const res = await fetch(`${apiUrl}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (res.ok && data.token) {
        onAuth(data.token);
      } else {
        setError(data.error || "Giriş başarısız.");
      }
    } catch {
      setError("Sunucu hatası.");
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #e0e7ff 0%, #f7f7f7 100%)",
        padding: 16,
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 370,
          background: "#fff",
          padding: "32px 20px",
          borderRadius: 18,
          boxShadow: "0 4px 24px #0002",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            fontSize: 38,
            fontWeight: 800,
            color: "#3b3b99",
            marginBottom: 8,
            letterSpacing: 1,
            textAlign: "center",
          }}
        >
          <span role="img" aria-label="logo">
            ⏻
          </span>{" "}
          İyiliğin Mucitleri
        </div>
        <h2 style={{ textAlign: "center", marginBottom: 24, color: "#222" }}>
          Giriş Yap
        </h2>
        <form onSubmit={handleSubmit} style={{ width: "100%" }}>
          <div style={{ marginBottom: 18 }}>
            <label style={{ fontWeight: 600, color: "#444" }}>E-posta</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{
                width: "100%",
                padding: 10,
                marginTop: 6,
                borderRadius: 8,
                border: "1px solid #d1d5db",
                fontSize: 15,
                outline: "none",
                background: "#f5f7fa",
              }}
              placeholder="E-posta adresiniz"
            />
          </div>
          <div style={{ marginBottom: 18 }}>
            <label style={{ fontWeight: 600, color: "#444" }}>Şifre</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{
                width: "100%",
                padding: 10,
                marginTop: 6,
                borderRadius: 8,
                border: "1px solid #d1d5db",
                fontSize: 15,
                outline: "none",
                background: "#f5f7fa",
              }}
              placeholder="Şifreniz"
            />
            <div style={{ fontSize: 12, color: "#888", marginTop: 4 }}>
              Şifre en az 8 karakter olmalı.
            </div>
            <div style={{ marginTop: 6, textAlign: 'right' }}>
              <Link
                to="/forgot-password"
                style={{ color: '#3b3b99', fontSize: 13, textDecoration: 'underline', fontWeight: 500 }}
              >
                Şifremi unuttum
              </Link>
            </div>
          </div>
          {error && (
            <div
              style={{
                color: "#e53935",
                marginBottom: 14,
                background: "#ffeaea",
                padding: "8px 12px",
                borderRadius: 6,
                fontSize: 14,
              }}
            >
              {error}
            </div>
          )}
          <button
            type="submit"
            style={{
              width: "100%",
              padding: "12px 0",
              background: "linear-gradient(90deg, #6366f1 0%, #3b3b99 100%)",
              color: "#fff",
              border: "none",
              borderRadius: 8,
              fontWeight: 700,
              fontSize: 17,
              letterSpacing: 1,
              marginTop: 4,
              boxShadow: "0 2px 8px #6366f122",
              cursor: "pointer",
              transition: "background 0.2s",
            }}
          >
            Giriş Yap
          </button>
        </form>
        <div style={{ marginTop: 22, textAlign: "center", fontSize: 15 }}>
          Hesabınız yok mu?{" "}
          <Link
            to="/register"
            style={{
              color: "#3b3b99",
              textDecoration: "underline",
              fontWeight: 600,
            }}
          >
            Kayıt Ol
          </Link>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;